import { render, staticRenderFns } from "./TeacherProfileMain.vue?vue&type=template&id=69ad0448&scoped=true"
import script from "./TeacherProfileMain.vue?vue&type=script&lang=js"
export * from "./TeacherProfileMain.vue?vue&type=script&lang=js"
import style0 from "./TeacherProfileMain.vue?vue&type=style&index=0&id=69ad0448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ad0448",
  null
  
)

export default component.exports